export const DeleteConfirmationLoader = () => (
  <div className="flex flex-col items-center gap-3 ">
    <div className={'bg-skeleton-primary h-3 w-full animate-pulse rounded-lg text-transparent'}>
      .
    </div>
    <div className={'bg-skeleton-primary h-3 w-full animate-pulse rounded-lg text-transparent'}>
      .
    </div>
  </div>
)
